import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '成都英华科技有限公司【官网】',
            keepAlive: true
          }
        }, {//关于我们
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '关于我们'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '企业简介'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '企业文化'
              }
            },
            {
              path: '/software/honor',
              name: 'honor',
              component: resolve => require(['@/view/Software_honor'], resolve),
              meta: {
                title: '荣誉资质'
              },
              children: [
                {
                  path: '/software/honor/honorDetail',
                  name: 'honorDetail',
                  component: resolve => require(['@/view/Software_honor_detail'], resolve),
                  meta: {
                    title: '荣誉资质详情'
                  }
                },
              ]
            },
            {
              path: '/software/address',
              name: 'address',
              component: resolve => require(['@/view/Software_address'], resolve),
              meta: {
                title: '联系我们'
              }
            },
          ]
        }, {//项目案例
          path: '/Mainbus',
          name: 'Mainbus',
          component: resolve => require(['@/view/Mainbus'], resolve),
          meta: {
            title: '项目案例'
          },
          children: [
            {
              path: '/Mainbus/info',
              name: 'info',
              component: resolve => require(['@/view/Mainbus_info'], resolve),
              meta: {
                title: '信息系统集成'
              },
              children: [
                {
                  path: '/Mainbus/infoDetail',
                  name: 'infoDetail',
                  component: resolve => require(['@/view/Mainbus_info_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/Mainbus/three',
              name: 'three',
              component: resolve => require(['@/view/Mainbus_three'], resolve),
              meta: {
                title: '三维数字服务'
              },
              children: [
                {
                  path: '/Mainbus/threeDetail',
                  name: 'threeDetail',
                  component: resolve => require(['@/view/Mainbus_three_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/Mainbus',
              redirect: '/Mainbus/info'
            },
            {
              path: '/Mainbus/development',
              name: 'development',
              component: resolve => require(['@/view/Mainbus_development'], resolve),
              meta: {
                title: '数据分析应用'
              },
              children: [
                {
                  path: '/Mainbus/deveDetail',
                  name: 'deveDetail',
                  component: resolve => require(['@/view/Mainbus_deve_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/Mainbus/services',
              name: 'services',
              component: resolve => require(['@/view/Mainbus_services'], resolve),
              meta: {
                title: '软件平台开发'
              },
              children: [
                {
                  path: '/Mainbus/servicesDetail',
                  name: 'servicesDetail',
                  component: resolve => require(['@/view/Mainbus_services_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
          ]
        }, {
          path: '/case', // 主营业务
          name: 'case',
          component: resolve => require(['@/view/Case'], resolve),
          meta: {
            title: '主营业务'
          },
          children: [
            {
              path: '/case/caseOne',
              name: 'caseOne',
              component: resolve => require(['@/view/CaseOne'], resolve),
              meta: {
                title: '信息系统集成'
              },
              children: [
                {
                  path: '/case/caseOne_detail',
                  name: 'oneDetail',
                  component: resolve => require(['@/view/CaseOne_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/case',
              redirect: '/case/caseOne'
            },
            {
              path: '/case/caseTwo',
              name: 'caseTwo',
              component: resolve => require(['@/view/CaseTwo'], resolve),
              meta: {
                title: '软件定制开发'
              },
              children: [
                {
                  path: '/case/caseTwo_detail',
                  name: 'twoDetail',
                  component: resolve => require(['@/view/CaseTwo_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/case/caseThree',
              name: 'caseThree',
              component: resolve => require(['@/view/CaseThree'], resolve),
              meta: {
                title: '三维数字服务'
              },
              children: [
                {
                  path: '/case/caseThree_detail',
                  name: 'threeDetail',
                  component: resolve => require(['@/view/CaseThree_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
            {
              path: '/case/caseFour',
              name: 'caseFour',
              component: resolve => require(['@/view/CaseFour'], resolve),
              meta: {
                title: '数据分析应用'
              },
              children: [
                {
                  path: '/case/caseFour_detail',
                  name: 'fourDetail',
                  component: resolve => require(['@/view/CaseFour_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
          ]
        }, {//新闻动态
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/News'], resolve),
          meta: {
            title: '新闻动态'
          },
          children: [
            {
              path: '/news',
              redirect: '/news/newsCompany'
            },
            {
              path: '/news/newsCompany',
              name: 'newsCompany',
              component: resolve => require(['@/view/News_company'], resolve),
              meta: {
                title: '企业新闻'
              },
              children: [
                {
                  path: '/news/newsCompanyDetail',
                  name: 'newsCompanyDetail',
                  component: resolve => require(['@/view/NewsCompany_detail'], resolve),
                  meta: {
                    title: '正文'
                  },
                },
              ]
            },
            {
              path: '/news/newsIndustry',
              name: 'newsIndustry',
              component: resolve => require(['@/view/News_industry'], resolve),
              meta: {
                title: '行业新闻'
              },
              children: [
                {
                  path: '/news/newsDetail',
                  name: 'newsDetail',
                  component: resolve => require(['@/view/News_detail'], resolve),
                  meta: {
                    title: '正文'
                  },
                },
              ]
            },
          ]
        }, {//党建动态
          path: '/party',
          name: 'party',
          component: resolve => require(['@/view/Party'], resolve),
          meta: {
            title: '企业党建'
          },
          children: [
            {
              path: '/party',
              redirect: '/party/partyDynamic'
            },
            {
              path: '/party/partyDynamic',
              name: 'partyDynamic',
              component: resolve => require(['@/view/Party_dynamic'], resolve),
              meta: {
                title: '党建动态'
              },
              children: [
                {
                  path: '/party/partyDetailOne',
                  name: 'partyDetailOne',
                  component: resolve => require(['@/view/party_detailOne'], resolve),
                  meta: {
                    title: '正文'
                  },
                }
              ]
            },
            {
              path: '/party/partyResponsibility',
              name: 'partyResponsibility',
              component: resolve => require(['@/view/Party_responsibility'], resolve),
              meta: {
                title: '社会责任'
              },
              children: [
                {
                  path: '/party/partyDetailTwo',
                  name: 'partyDetailTwo',
                  component: resolve => require(['@/view/party_detailTwo'], resolve),
                  meta: {
                    title: '正文'
                  },
                }
              ]
            },
          ]
        }, {
          path: '/work',
          name: 'work',
          component: resolve => require(['@/view/Work'], resolve),
          meta: {
            title: '人力资源'
          },
          children: [
            {
              path: '/work',
              redirect: '/work/workList'
            },
            {
              path: '/work/workList',
              name: 'workList',
              component: resolve => require(['@/view/Work_list'], resolve),
              meta: {
                title: '感知与收获'
              },
              children: [
                {
                  path: '/work/workDtail',
                  name: 'workDtail',
                  component: resolve => require(['@/view/Work_detail'], resolve),
                  meta: {
                    title: '正文'
                  }
                },
              ]
            },
          ]
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js